import { flattenEntry, Page } from '@/lib/cms';

import { BlockComponentModel } from '@/components/cms/types/blok-component';
import { TopicEntry } from '@/components/cms/types/entry';

import { ArticlesFeed } from './ArticlesFeed';

export interface ArticlesFeedStrapiProps {
  filters: boolean;
  search: boolean;
  paginationLabel: string;
  featuredTopics: Page<TopicEntry>;
}

export async function ArticlesFeedStrapi({
  block,
  pageData,
}: BlockComponentModel<ArticlesFeedStrapiProps>) {
  const {
    filters: hasFilters,
    search: hasSearch,
    paginationLabel,
    featuredTopics,
  } = block;

  const pageSlug = pageData?.params?.slug;

  const getTopicSlug = (slug?: string | string[]) => {
    if (!Array.isArray(slug)) return slug;
    return slug[0];
  };

  const topicSlug = getTopicSlug(pageSlug);

  return (
    <ArticlesFeed
      initialTopicSlug={getTopicSlug(pageSlug)}
      hasFilters={!topicSlug && hasFilters}
      hasSearch={!topicSlug && hasSearch}
      featuredTopics={featuredTopics?.data.map(flattenEntry)}
      paginationLabel={paginationLabel ?? 'Load more'}
    />
  );
}
